// One basket line, shared by cart checkout, the approval modal, My Requests and the
// Activity Log so adds and removes read identically everywhere. colSpanForName
// defaults to 1; some surfaces span a Lines column the others do not.

import React from 'react'

const DirectionIcon = ({ delta }) => {
  if (delta > 0) {
    // ↑ in success green
    return (
      <span style={{ color: '#1e7e34', fontWeight: 'bold', marginRight: 6 }}
        title="Adding seats">
        ↑
      </span>
    )
  }
  if (delta < 0) {
    return (
      <span style={{ color: '#c82333', fontWeight: 'bold', marginRight: 6 }}
        title="Removing seats">
        ↓
      </span>
    )
  }
  // No change - shouldn't happen on a valid basket but render
  // something sensible anyway.
  return (
    <span style={{ color: '#6c757d', fontWeight: 'bold', marginRight: 6 }}
      title="No change">
      –
    </span>
  )
}

const formatSignedDelta = (delta) => {
  if (delta > 0) return `+${delta}`
  if (delta < 0) return `−${Math.abs(delta)}` // U+2212 minus sign, visually heavier than the keyboard hyphen
  return '0'
}

const BasketLineRow = ({
  skuDisplayName,
  stockCode,
  stockDescription,
  previousQuantity,
  requestedQuantity,
}) => {
  const delta = requestedQuantity - previousQuantity
  const deltaColor = delta > 0 ? '#1e7e34' : delta < 0 ? '#c82333' : '#6c757d'
  const tooltip = stockDescription && stockDescription !== skuDisplayName
    ? stockDescription : undefined

  return (
    <tr>
      <td>
        <div title={tooltip}>
          <DirectionIcon delta={delta} />
          {skuDisplayName}
        </div>
        <code className="small text-muted" style={{ marginLeft: 22 }}>{stockCode}</code>
      </td>
      <td className="text-right">{previousQuantity}</td>
      <td className="text-right">
        {requestedQuantity}{' '}
        <small style={{ color: deltaColor, fontWeight: 'bold' }}>
          ({formatSignedDelta(delta)})
        </small>
      </td>
    </tr>
  )
}

export default BasketLineRow
